import axios from 'axios'; // Correct way
import { uri } from '../backendUri';
import { message } from 'antd';

// Create an axios instance if needed (optional)
const axiosApi = axios.create({
    //  baseURL: uri,

    baseURL: 'https://srv801875.hstgr.cloud/api',
    // baseURL: 'http://localhost:8080/api',
});

axiosApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
},
    (error) => {
        console.error('Request error:', error);

        return Promise.reject(error);
    }
);

axiosApi.interceptors.response.use(async (response) => {

    if (response?.data?.token) {
        localStorage.setItem('authToken', response.data.token)
    }

    return response;
},
    (error) => {
        if (error.response && error.response.status === 401) {
            console.log('Unauthorized, redirecting to login...');
            message.error(error.message)
        }
        return Promise.reject(error);
    }
);

export default axiosApi;